<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 25L29 25" stroke="white" stroke-width="2" stroke-linecap="round" />
    <path d="M16 25L23 32" stroke="white" stroke-width="2" stroke-linecap="round" />
    <path d="M23 18L16 25" stroke="white" stroke-width="2" stroke-linecap="round" />
    <path d="M34 16L34 34" stroke="white" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 50 },
    height: { type: [Number, String], default: 50 },
    color: { type: String, default: '#80B7FF' }
  }
};
</script>

<style>
</style>